import {MSG_TYPES, MESSAGE_PROP_MSG_TYPE} from '@/constants/inbox-messages';
import {toPhilMoment} from '@/utils/dates';
import {PageTypes} from "@/reference";

export const getMessageMomentDate = (message) => {
  let date = message.date;

  if (message.datecreated) { // for attachment
    date = message.datecreated;
  } else if (message.start_date) { // for session
    date = message.start_date;
  } else if (message.received) {
    date = message.received;
  }

  return toPhilMoment(date);
};

export const addMessageFromProp = (message) => {
  if (message.msgtype === MSG_TYPES.attachment) {
    message.from = 0;
  }
};

export const transformReceivedMessage = (message) => {
  if (message.attachments && message.attachments.length) {
    message.msgtype = MSG_TYPES.multipleAttachments;
  }

  if (message.pagetype === PageTypes.labtest) {
    message.msgtype = MSG_TYPES.labtest;
  }

  if (message.pagetype === PageTypes.prescription) {
    message.msgtype = MSG_TYPES.prescription
  }

  if (message.pagetype === PageTypes.educ) {
    message.msgtype = MSG_TYPES.file;
  }

  return message;
};

export const getDoctorMessagePreviewText = (message, doctor) => {
  if (message.msgtype === MSG_TYPES.pxbill) {
    return `${doctor._fullName} sent you a bill`;
  } else {
    return message[MESSAGE_PROP_MSG_TYPE[message.msgtype]];
  }
};

export const setDoctorSocketMessageType = (message) => {
  if (message.type) {
    message.msgtype = message.type;
  } else if (message.mimetype) {
    message.msgtype = MSG_TYPES.file;
  } else {
    message.msgtype = MSG_TYPES.message;
  }

  if (message.pagetype === PageTypes.labtest) {
    message.msgtype = MSG_TYPES.labtest;
  }

  if (message.pagetype === PageTypes.prescription) {
    message.msgtype = MSG_TYPES.prescription
  }
};

export const getSavedUnreadCount = () => {
  const savedCount = localStorage.getItem('unread');

  try {
    return JSON.parse(savedCount) || {};
  } catch (error) {
    return {};
  }
};

export const saveUnreadCount = (unreadCount) => {
  localStorage.setItem('unread', JSON.stringify(unreadCount));
};
